<template>
    <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <vs-card>
                <div slot="header">
                    <h3>
                        <feather-icon icon-pack="feather-icon" icon="CpuIcon"></feather-icon>
                        All Interfaces
                    </h3>
                </div>
                <vs-input icon-pack="feather" icon="icon-search" label-placeholder="Search" v-model="search" class="is-label-placeholder float-right"/>
                <div class="el-table">
                    <data-tables-server @sort-change="sortChange" @query-change="fetchData" :loading="loader" :data="data">
                        <el-table-column align="center" sortable prop="id" label="ID#"></el-table-column>
                        <el-table-column align="center" sortable prop="title" label="Title"></el-table-column>
                        <el-table-column align="center" prop="details" label="Details">
                            <template scope="scope">
                                <vs-button class="options" size="small" icon-pack="feather" icon="icon-eye" color="gray" @click="showDetails(scope.$index ,scope.row)" type="filled">Show</vs-button>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" sortable prop="created_at" label="Created At"></el-table-column>
                    </data-tables-server>
                    <div style="padding: 15px;" align="center">
                        <el-pagination @current-change="handleCurrentChange" :page-size="pageSize" @size-change="handleSizeChange" :total="total" :current-page="page" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
                    </div>
                </div>
                <vs-popup class="holamundo" title="Details" :active.sync="popupActiveDetails">
                    <div v-if="showed_data">
                        <h5><b>Title:</b> {{showed_data.title}}</h5>
                        <h5><b>Description:</b></h5>
                        <p>{{showed_data.description}}</p>
                        <h5><b>Http Method:</b> {{showed_data.http_method}}</h5>
                        <h5><b>URL:</b> <a :href="showed_data.url"> {{showed_data.url}}</a></h5>
                        <h5><b>Port:</b> {{showed_data.port}} </h5>
                        <h5><b>Headers:</b></h5>
                        <pre>{{showed_data.headers}}</pre>
                        <h5><b>Body:</b></h5>
                        <pre>{{showed_data.body}}</pre>
                    </div>
                </vs-popup>
            </vs-card>
        </vs-col>
    </vs-row>

</template>


<script>

    import Configs from '../../config.js';

    export default {
        data() {
            return {
                popupActiveDetails: false,
                selected: [],
                data: [],
                search: '',
                page: null,
                total: null,
                pageSize: null,
                loader: false,
                prop: null,
                sort: null,
                showed_data: null,
                dialogRow:null
            }
        },
        mounted() {
            this.fetchData();
        },
        created() {
            this.setBreadCrumbsItems();
        },
        watch: {
            search: function () {
                this.fetchData();
            }
        },
        methods: {
            showDetails(index, row) {
                this.popupActiveDetails = true;
                this.showed_data = row;
            },
            sortChange(sortProps) {
                this.headerClick(sortProps.column, event)
            },
            headerClick(column, event) {
                this.prop = column.property;
                this.sort = column.order;
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.fetchData();
            },
            handleCurrentChange(val) {
                this.page = val;
                this.fetchData();
            },
            fetchData() {
                this.loader = true;
                Window.axios({
                    method: 'post',
                    url: Configs.host + '/api/v1/interfaces/get-interfaces',
                    data: {
                        page: this.page,
                        pageSize: this.pageSize,
                        search: this.search,
                        sort: this.sort,
                        prop: this.prop
                    },
                    headers: {
                        "Accept": "application/json",
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + this.$store.state.AppActiveUser.token
                    }
                }).then((response) => {
                    this.total = response.data.total;
                    this.data = response.data.data;
                    this.loader = false;
                }).catch((err) => {
                    console.log(err.response);
                    this.loader = false;
                })
            },
            setBreadCrumbsItems() {
                let items = [
                    {
                        title: 'Interfaces',
                    },
                    {
                        title: 'Show All Interfaces',
                        active: true
                    }
                ];
                this.$store.commit("SetBreadCrumbsItems", items)
            }
        }
    }
</script>

<style>
    .pagination-bar {
        display: none;
    }

    pre {
        background: #1a1a1a;
        border: 1px solid #ddd;
        border-left: 3px solid #3554f3;
        color: #b8a460;
        page-break-inside: avoid;
        font-family: monospace;
        font-size: 15px;
        line-height: 1.6;
        margin-bottom: 1.6em;
        max-width: 100%;
        overflow: auto;
        padding: 1em 1.5em;
        display: block;
        word-wrap: break-word;
    }

    .options {
        margin: 1px !important;
        display: inline-flex !important;
    }

    .con-vs-popup .vs-popup {
        width: 1200px;
    }
</style>